import React from 'react';

type CustomRadioInputProps = {
  checked: boolean;
  handleChange: () => void;
  item: string;
  methodDetails: Record<
    string,
    {
      label: string;
      icon?: JSX.Element;
      logo?: JSX.Element;
    }
  >;
};

const CustomRadioInput: React.FC<CustomRadioInputProps> = ({
  checked,
  handleChange,
  item,
  methodDetails,
}) => {
  const details = methodDetails[item] || {
    label: '',
    icon: null,
    logo: null,
  };

  return (
    <label className="flex items-center p-3 border-none rounded-md cursor-pointer">
      <div className="relative mr-3">
        <input
          type="radio"
          className="sr-only"
          checked={checked}
          onChange={handleChange}
          name={item}
        />
        <div
          className={`
            relative flex items-center justify-center
            w-3.5 h-3.5 rounded-full cursor-pointer
            transition-all duration-200 ease-in-out
            ${
              checked
                ? 'bg-gray-700 border-2 border-gray-700'
                : 'bg-white border-2 border-gray-300 hover:border-gray-400'
            }
          `}>
          {checked && <div className="w-[5px] h-[5px] bg-white rounded-full" />}
        </div>
      </div>
      <span className="flex items-center text-sm font-semibold text-borderGreyHover">
        {details.icon}
        {details.label}
      </span>
      <div className="ml-auto flex">{details.logo}</div>
    </label>
  );
};

export default CustomRadioInput;
